/* HydratBath — np-ui.js
   Gedeelde carousels en accordions. Geen externe libraries. */
(function () {
  'use strict';

  /* ---------- Carousels ---------- */
  function initCarousel(root) {
    var vp = root.querySelector('[data-np-vp]');
    if (!vp) return;
    var items = vp.children;
    if (items.length < 2) {
      root.querySelectorAll('[data-np-prev],[data-np-next],[data-np-dots]').forEach(function (el) { el.remove(); });
      return;
    }

    var prev = root.querySelector('[data-np-prev]');
    var next = root.querySelector('[data-np-next]');
    var dotWrap = root.querySelector('[data-np-dots]');
    var dots = [];

    function step() { return items[0].getBoundingClientRect().width + 12; }
    function index() { return Math.round(vp.scrollLeft / step()); }
    function goTo(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      vp.scrollTo({ left: step() * i, behavior: 'smooth' });
    }

    if (dotWrap) {
      Array.prototype.forEach.call(items, function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'np-photorev__dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Ga naar item ' + (i + 1));
        b.addEventListener('click', function () { goTo(i); });
        dotWrap.appendChild(b);
        dots.push(b);
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });

    var raf;
    vp.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = index();
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      });
    });
  }

  document.querySelectorAll('[data-np-carousel]').forEach(initCarousel);

  /* ---------- Accordions ---------- */
  document.querySelectorAll('[data-np-accordion]').forEach(function (list) {
    var single = list.hasAttribute('data-np-single');
    list.querySelectorAll('[data-np-acc-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.np-faq__item');
        var open = item.classList.contains('is-open');
        if (single) {
          list.querySelectorAll('.np-faq__item.is-open').forEach(function (o) {
            o.classList.remove('is-open');
            o.querySelector('[data-np-acc-q]').setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  });
})();
